import type { BenchmarkGranularity } from "../../../types/common";

export enum ValueType {
    Absolute = "absolute",
    Percentage = "percentage",
}

export type TrendChangeTooltipSchema = {
    value: number;
    change: number;
    granularity: BenchmarkGranularity;
    date: string;
    valueType?: ValueType;
};
